<template>
  <div>
    <v-toolbar dense tile flat :elevation="1">
      <v-tabs v-model="tab" cols="12" :class="{'my-2': !dense }">
        <v-tab v-for="category in getCategories" :key="category.id">
          <v-badge
              :value="getItemsQuantityByCategory(category)"
              :color="category.fontColor"
              :content="getItemsQuantityByCategory(category)"
          >
            {{ category.name }}
          </v-badge>

        </v-tab>

        <v-tab key="promos">
          <v-badge :value="getPromoQuantity" :content="getPromoQuantity">
          Promos
          </v-badge>
        </v-tab>

      </v-tabs>
      <v-spacer></v-spacer>
      <v-text-field
          placeholder="buscar..."
          v-model="search"
          solo hide-details dense clearable
          class="mx-2"
      ></v-text-field>
      <gallery-view-buttons></gallery-view-buttons>
    </v-toolbar>

    <v-card  :loading="loading" outlined tile >
      <v-card-text v-if="!loading" class="pt-2 px-2" :style="{maxHeight: productCardHeight+'px',  overflowY: 'auto',}">
        <v-tabs-items v-model="tab">

          <v-tab-item v-for="category in getCategories" :key="category.id">
            <v-row dense>
              <v-col v-for="item in getProductsByCategory(category)"
                     :key="item.product.id"
                     cols="12" :sm="galleryView"
              >
                <bar-product-card
                    :product="item.product"
                    :category="category"
                    :order="item.order"
                    :quantity="$store.getters.orderSystem.cartService.getQuantityByProductAndCategory(item.product, category)"
                    :stock-quantity="item.quantity"
                    edit-quantity
                    :short-name="galleryView === 4"
                />

              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item key="promos">
            <v-row v-if="stock">
              <v-col cols="12" >
                <h5 class="text-h4 grey--text text--darken-4 font-weight-bold">Promos</h5>
                <v-divider></v-divider>
              </v-col>

              <!--PROMOS-->
              <v-col cols="8" >
                <v-row >
                  <v-col  v-for="promo in getActivePromos"
                          :key="promo.id"
                          cols="12" :sm="6" :md="6"
                  >
                    <promo-card
                        :promo="promo"
                        :stock="stock"
                        :quantity="getQuantityByPromo(promo)"
                    />
                  </v-col>
                </v-row>

              </v-col>

              <v-col cols="4" >
               <v-card outlined >
                 <v-card-title>Promos Cargadas</v-card-title>
                   <div :style="{maxHeight: '450px', overflowY: 'auto'}" v-if="getOrderPromos.length > 0">
                     <v-list class="px-2 pt-0" dense>
                       <v-divider></v-divider>
                         <div v-for="orderPromo in getOrderPromos" :key="orderPromo.id">
                           <customer-cart-detail-promo
                               :order-promo="orderPromo"
                               :show-remove-button="true"
                           ></customer-cart-detail-promo>
                           <v-divider class="my-2"></v-divider>
                         </div>
                     </v-list>
                   </div>
               </v-card>
              </v-col>

            </v-row>
          </v-tab-item>
        </v-tabs-items>



      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import StockProvider from "@/modules/delivery/providers/StockProvider";
import GalleryViewButtons from "@/modules/delivery/components-core/shared/GalleryViewButtons/GalleryViewButtons.vue";
import BarProductCard from "@/modules/delivery/components-core/business/BarProductCard/BarProductCard.vue";
import PromoCard from "@/modules/delivery/components-core/shared/PromoCard/PromoCard.vue";
import CustomerCartDetailPromo
  from "@/modules/delivery/components-core/customer/CustomerCartDetail/CustomerCartDetailPromo.vue";

export default {
  name: "BarProductGallery",
  components: {CustomerCartDetailPromo, PromoCard, BarProductCard, GalleryViewButtons},
  props: {
    dense: {type: Boolean, default: false}
  },
  data() {
    return {
      stock: null,
      categories: [],
      filters: {
        name: null,
        ingredients: [],
        category: null
      },
      loading: false,
      tab: 0,
      search: ''
    }
  },
  created() {
    this.$store.dispatch('fetchCategories')
    this.$store.dispatch('fetchPromos')
    this.checkBranch().then(() => this.fetchStockProducts())
  },
  computed: {
    windowHeight() {
      return window.innerHeight
    },
    productCardHeight() {
      return this.windowHeight ? this.windowHeight - 185 : 450
    },

    galleryView() {
      return this.$store.getters.galleryView
    },
    productItems() {
      return this.stock ? this.stock.items.filter(item => item.product) : []
    },
    getCategoriesMenu() {
      return this.$store.getters.getCategories.map(category => {
        return category.name
      })
    },
    getOrder() {
      return this.$store.getters.orderSystem.order
    },
    getOrderItems() {
      return this.$store.getters.orderSystem.order.items
    },
    getOrderPromos() {
      return this.$store.getters.orderSystem.order.promos
    },
    getCategories() {
      if (this.filters.category) {
        return this.$store.getters.getCategories.filter(c => c.id === this.filters.category)
      }
      return this.$store.getters.getCategories
    },
    getProductsByCategory() {
      return category => {
        if (!this.search) {
          return this.productItems.filter(item => item.product.active && item.product.categories.some(c => c.id === category.id))
        } else {
          return this.productItems.filter(item => item.product.active && item.product.categories.some(c => c.id === category.id) && (item.product.name.toLowerCase().includes(this.search) || item.product.shortName.toLowerCase().includes(this.search)))
        }
      }
    },
    getItemsQuantityByCategory() {
      return category => {
        return this.$store.getters.orderSystem.cartService.getQuantityByCategory(category)
      }
    },
    getQuantityByPromo(){
      return (promo) => {
        return this.$store.getters.orderSystem.cartService.getQuantityByPromo(promo)
      }
    },
    getPromoQuantity(){
      return this.$store.getters.orderSystem ? this.$store.getters.orderSystem.cartService.getPromoQuantity : 0
    },
    getOrderDeliveryMode() {
      return this.$store.getters.orderSystem.order.getDeliveryMode
    },
    getActivePromos() {
      let dt = this.getOrderDateTime
      return this.$store.getters.promos
          .filter(promo => {
            return promo.isActive() && promo.isActive(dt)
          })
          .filter(promo => {
            return promo.mode && promo.mode.length > 0 ? promo.mode.includes(this.getOrderDeliveryMode) : true
          })
    }
  },
  methods: {
    async checkBranch() {
      if (!this.branch) {
        await this.$store.dispatch('fetchDefaultBranch')
      }
      return this.branch
    },
    fetchStockProducts() {
      this.loading = true
      StockProvider.findStockByBranch(this.$store.getters.branchSelected.id)
          .then(r => {
            this.stock = r.data.findStockByBranch
          })
          .catch(e => {
            console.error(e)
          })
          .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
